import { render } from "./PopUpVideo.vue?vue&type=template&id=3cbfe868"
import script from "./PopUpVideo.vue?vue&type=script&lang=js"
export * from "./PopUpVideo.vue?vue&type=script&lang=js"

import "./PopUpVideo.vue?vue&type=style&index=0&id=3cbfe868&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__